defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewCoupon/DrawsList',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewCoupon/DrawsListItem',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Modal'
  ],
  function (m, DrawsListItem) {

    var gameTypeMap = {
      LottoSaturday: 'Lotto',
      EuroJackpot: 'Eurojackpot',
      VikingLotto: 'Vikinglotto'
    };
    var DrawsList = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.gameType = gameTypeMap[this.play.game];
        this.draws = this.play.draws.map((draw) => {
          const hasPassed = new Date(draw.drawDate) < new Date();
          draw.hasPassed = hasPassed;
          return draw;
        });
        this.openedItem = m.prop(null);

        this.myFunding = m.prop(this.play.playerFundingDetails.find((player) => {
          return player.playerId === this.currentUserId();
        }));
      },
      view: function (controller) {
        // View:
        return m('div', [
          m('.play-together-coupon-draw-list',
            controller.draws.map((drawItem) => {
              return m(DrawsListItem, { controller, drawItem });
            })
          ),
          m('.play-together-coupon-draw-list__description',
            m.trust(controller.dictionary('DrawsSection/Description'))
          )
        ]);
      }
    };

    // Public functions:
    return DrawsList;
  });
